// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_confirmation_footer-module__container--1yRRc{padding:32px}@media screen and (max-width: 48em){.modal_confirmation_footer-module__container--1yRRc{padding:32px 24px 24px}}\n", ""]);
// Exports
exports.locals = {
	"container": "modal_confirmation_footer-module__container--1yRRc"
};
module.exports = exports;
